import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { externalServiceSelectors } from '@/redux/selectors';
import {
  listenToHelpCrunch,
  rememberAdClicks,
  syncHelpCrunchAttribution,
} from '@/utils/attribution';

const useHelpCrunchAttribution = (): void => {
  const { pathname, search } = useLocation();
  const helpcrunchLoaded = useAppSelector(
    externalServiceSelectors.helpcrunchLoaded,
  );

  useEffect(() => {
    rememberAdClicks(search);
  }, [search]);

  useEffect(() => {
    if (helpcrunchLoaded) listenToHelpCrunch();
  }, [helpcrunchLoaded]);

  useEffect(() => {
    if (helpcrunchLoaded) syncHelpCrunchAttribution();
  }, [helpcrunchLoaded, pathname, search]);
};

export default useHelpCrunchAttribution;
